module.exports = __webpack_public_path__ + "static/img/fgbg2-7.ab8315d.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-7.png
// module id = 198
// module chunks = 0